{
  "definition": {
    "$defs": {
      "operators": {
        "type": "string",
        "enum": [">", ">=", "<", "<=", "==", "!=", "has", "hasAncestorsOf", "hasDescendantsOf", "hasParentsOf", "hasChildrenOf", "and", "or", "+", "-", "*", "/", "**", "%"]
      },
      "binaryExpression": {
        "type": "object",
        "properties": {
          "operator": { "$ref": "#/$defs/operators" },
          "expression1": {
            "oneOf": [
              { "type": "string" },
              { "type": "number" },
              { "$ref": "#/$defs/binaryExpression" }
            ]
          },
          "expression2": {
            "oneOf": [
              { "type": "string" },
              { "type": "number" },
              { "$ref": "#/$defs/binaryExpression" }
            ]
          }
        },
        "required": ["operator", "expression1", "expression2"],
        "additionalProperties": false
      },
      "nodeActionType": {
        "type": "string",
        "enum": ["manage", "read", "approve", "reject", "submit", "revert", "start", "update"]
      },
      "actionPolicy": {
        "type": "object",
        "properties": {
          "type": { "$ref": "#/$defs/nodeActionType" },
          "allow": { "$ref": "#/$defs/binaryExpression" },
          "description": { "type": "string" }
        },
        "required": ["type", "allow"],
        "additionalProperties": false
      },
      "flowType": {
        "type": "string",
        "enum": ["normal", "approve", "reject", "submit"]
      },
      "position": {
        "type": "object",
        "properties": {
          "x": { "type": "number" },
          "y": { "type": "number" }
        },
        "required": ["x", "y"]
      },
      "condition": {
        "type": "object",
        "properties": {
          "type": { "$ref": "#/$defs/flowType" },
          "expression": { "$ref": "#/$defs/binaryExpression" },
          "destination": { "type": "string" }
        },
        "required": ["expression", "destination"],
        "additionalProperties": false
      }
    },
    "type": "object",
    "properties": {
      "edges": {
        "type": "array",
        "items": {
          "type": "object",
          "properties": {
            "to": { "type": "string" },
            "from": { "type": "string" },
            "type": {
              "type": "array",
              "minItems": 1,
              "items": { "type": "string" }
            }
          },
          "required": ["to", "from", "type"],
          "additionalProperties": false
        }
      },
      "nodes": {
        "type": "array",
        "items": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "id": { "type": "string" },
                "name": { "type": "string" },
                "type": { "const": "event" },
                "eventType": { "type": "string", "enum": ["start", "end"] },
                "position": { "$ref": "#/$defs/position" },
                "actionPolicies": {
                  "type": "array",
                  "items": { "$ref": "#/$defs/actionPolicy" }
                }
              },
              "required": ["id", "name", "type", "eventType"]
            },
            {
              "type": "object",
              "properties": {
                "id": { "type": "string" },
                "name": { "type": "string" },
                "type": { "const": "task" },
                "position": { "$ref": "#/$defs/position" },
                "canRevert": { "type": "boolean" },
                "actionPolicies": {
                  "type": "array",
                  "items": { "$ref": "#/$defs/actionPolicy" }
                }
              },
              "required": ["id", "name", "type"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "id": { "type": "string" },
                "name": { "type": "string" },
                "type": { "const": "exclusiveFork" },
                "position": { "$ref": "#/$defs/position" },
                "conditions": {
                  "type": "array",
                  "items": { "$ref": "#/$defs/condition" }
                }
              },
              "required": ["id", "name", "type"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "id": { "type": "string" },
                "name": { "type": "string" },
                "type": { "const": "parallelFork" },
                "position": { "$ref": "#/$defs/position" },
                "keys": {
                  "type": "object",
                  "properties": {
                    "name": { "type": "string" },
                    "enum": { "type": "string" }
                  },
                  "required": ["name", "enum"],
                  "additionalProperties": false
                }
              },
              "required": ["id", "name", "type"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "id": { "type": "string" },
                "name": { "type": "string" },
                "type": { "const": "parallelJoin" },
                "position": { "$ref": "#/$defs/position" },
                "conditions": {
                  "type": "array",
                  "items": { "$ref": "#/$defs/condition" }
                }
              },
              "required": ["id", "name", "type"],
              "additionalProperties": false
            }
          ]
        }
      }
    },
    "additionalProperties": false
  },
  "dataSchema": {
    "type": "object",
    "properties": {
      "type": { "const": "object" },
      "additionalProperties": { "const": false },
      "properties": {
        "type": "object",
        "additionalProperties": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "type": { "const": "string" },
                "title": { "type": "string" },
                "_order": { "type": "number" },
                "_acomoType": { "const": "string" },
                "description": { "type": "string" }
              },
              "required": ["type", "_order", "_acomoType"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": { "const": "string" },
                "title": { "type": "string" },
                "_order": { "type": "number" },
                "format": { "const": "date" },
                "_acomoType": { "const": "date" },
                "description": { "type": "string" }
              },
              "required": ["type", "_order", "_acomoType", "format"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": { "const": "number" },
                "title": { "type": "string" },
                "_order": { "type": "number" },
                "_acomoType": { "const": "number" },
                "description": { "type": "string" }
              },
              "required": ["type", "_order", "_acomoType"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": { "const": "string" },
                "title": { "type": "string" },
                "_order": { "type": "number" },
                "enum": {
                  "type": "array",
                  "items": { "type": "string" }
                },
                "_acomoType": { "const": "enum" },
                "description": { "type": "string" }
              },
              "required": ["type", "_order", "_acomoType", "enum"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": { "const": "array" },
                "items": {
                  "type": "object",
                  "properties": {
                    "type": { "const": "string" },
                    "pattern": { "const": "[^/]+" }
                  },
                  "required": ["type", "pattern"],
                  "additionalProperties": false
                },
                "title": { "type": "string" },
                "_order": { "type": "number" },
                "_acomoType": { "const": "file" },
                "description": { "type": "string" }
              },
              "required": ["type", "_order", "_acomoType", "items"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": { "const": "array" },
                "items": {
                  "type": "object",
                  "properties": {
                    "type": { "type": "string", "enum": ["string", "number"] },
                    "format": { "const": "date" }
                  },
                  "required": ["type"],
                  "additionalProperties": false
                },
                "title": { "type": "string" },
                "_order": { "type": "number" },
                "_acomoType": { "const": "array" },
                "description": { "type": "string" }
              },
              "required": ["type", "_order", "_acomoType", "items"],
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": { "const": "object" },
                "title": { "type": "string" },
                "_order": { "type": "number" },
                "_acomoType": { "const": "record" },
                "_recordKey": {
                  "type": "string",
                  "not": { "const": "" }
                },
                "description": { "type": "string" },
                "additionalProperties": {
                  "type": "object",
                  "properties": {
                    "type": { "type": "string", "enum": ["string", "number"] }
                  },
                  "required": ["type"],
                  "additionalProperties": false
                }
              },
              "required": ["type", "_order", "_acomoType", "_recordKey", "additionalProperties"],
              "additionalProperties": false
            }
          ]
        }
      }
    },
    "additionalProperties": false,
    "required": ["type"]
  },
  "dataAccessPolicy": {
    "type": "object",
    "additionalProperties": {
      "type": "object",
      "additionalProperties": { "type": "string", "enum": ["read", "write"] }
    }
  }
}
